import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyLeopardMode({ Copy }: ModeRendererProps) {
  const spots = [] as React.ReactNode[];
  for (let i = 0; i < 60; i++) {
    const x = 60 + (i % 10) * 68;
    const y = 100 + Math.floor(i / 10) * 90;
    spots.push(<circle key={i} cx={x} cy={y} r={18} fill="#7b3f1a" />);
  }
  return (
    <g>
      <rect width={794} height={1123} fill="#f2c27d" />
      {spots}
      <g className="mode-copy" transform="translate(48,840)" fill="#3b2f2b"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyLeopardMode;
